import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api, { GenericError } from "../api"
import { ListQueries, OrderModel } from "../api/order.api"

export interface OrdersListState {
    orders: OrderModel[]
    total: number
    loading: boolean
    //TODO: make error interface
    error?: GenericError
    success?: boolean
}

const initialState: OrdersListState = {
    orders: [],
    total: 0,
    loading: false
}

export const loadOrders = createAsyncThunk(
    "orders/list",
    async ({ warehouse, page, size, keyword }: ListQueries, thunkAPI) => {
        try {
            const response = await api.order.ordersList({ warehouse, page, size, keyword })

            return response
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const ordersSlice = createSlice({
    name: "orders",
    initialState,

    reducers: {
        clearError: (state: OrdersListState) => {
            state.error = undefined
        },
        resetSuccess: (state: OrdersListState) => {
            state.success = undefined
        }
    },

    extraReducers: {
        [loadOrders.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadOrders.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [loadOrders.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.orders = action.payload?.data?.payload?.orders_lists || []
            state.total = action.payload?.data?.payload?.total_pages || 0
        }
    }
})

export const { clearError, resetSuccess } = ordersSlice.actions

export default ordersSlice.reducer
